/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, Input } from '@angular/core';
import { IUserInfoModel } from '@nx-fe/services';

/** Component to display popup information for a user */
@Component({
  selector: 'xs-user-info-popup',
  templateUrl: './user-info-popup.component.html',
  styleUrls: ['./user-info-popup.component.scss'],
})
export class UserInfoPopupComponent {
  @Input()
  userInfo: IUserInfoModel;

  public getTooltipText = () => {
    const displayName = this.userInfo.displayName;
    const email = this.userInfo.email;
    return displayName + (email && email !== displayName ? ' - ' + email : '');
  };
}
